import { e } from "mathjs";
import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import ConfirmDialog from "../../ui/ConfirmDialog";
import './SystemMessages.scss'
import ListItem from "../../ui/ListItem";
import DropdownMenu from "../../ui/DropdownMenu";
import MenuItem from "../../ui/MenuItem";
type OwnProps = {


}

const SystemMessageScreen: FC<OwnProps> = ({


}) => {
    useEffect(() => {

    }, [])
    function loadSystemMessages(): string[] {
        const result: string[] = []
        for (let i = 1; i < 100; i++) {
            result.push(`Hệ thống thông báo số ${i}`)
        }
        return result
    }
    return (
        <div className="message-screen-main">
            <div className="message-screen-header">
                <div className=" common-container-row">
                    <div>Thông báo hệ thống</div>
                   <DropdownMenu positionX="right">
                        <MenuItem> Tạo thông báo mới</MenuItem>
                   </DropdownMenu>
                </div>
            </div>
            <div className="message-screen-list">

                {
                    loadSystemMessages().map((msg: any, index: number) => {
                        return <ListItem key={index} className="message-body">{msg}</ListItem>
                    })}

            </div>
        </div>
    )
}

export default memo(SystemMessageScreen);